import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Prohibit Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M128 2.56c-96.564 0-156.916 104.533-108.634 188.16s168.986 83.627 217.268 0A125.44 125.44 0 0 0 253.44 128C253.367 58.752 197.248 2.633 128 2.56M234.142 128a105.6 105.6 0 0 1-24.618 67.882L60.118 46.464c62.813-52.256 158.64-16.919 172.488 63.607A106 106 0 0 1 234.142 128m-212.283 0a105.6 105.6 0 0 1 24.617-67.882l149.406 149.418c-62.813 52.256-158.64 16.919-172.488-63.607A106 106 0 0 1 21.858 128" }, null, -1)
  ])))
}
export default { render: render }